import { useEffect, useLayoutEffect, useRef, useState } from "react";
import axios from "axios";
import { API } from "../../../App";

let cache = null;
let pending = null;

export const useAnalysisSpecs = () => {
  const [specs, setSpecs] = useState(cache);
  useEffect(() => {
    if (cache) return;
    pending = pending || axios.get(`${API}/session-analyses/specs`, { withCredentials: true }).then((r) => { cache = r.data; return cache; });
    pending.then(setSpecs).catch(() => {});
  }, []);
  return specs;
};

export const AutoTextarea = ({ value, onChange, placeholder, rows = 2, className = "", testId }) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight + 2}px`;
  }, [value, rows]);
  return (
    <textarea
      ref={ref}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      rows={rows}
      data-testid={testId}
      className={`w-full text-sm rounded-lg border border-border bg-background px-2.5 py-1.5 focus:outline-none focus:ring-2 focus:ring-primary/30 resize-none overflow-hidden ${className}`}
    />
  );
};

export const Field = ({ label, hint, children, testId }) => (
  <div className="space-y-1" data-testid={testId}>
    <div className="flex items-baseline justify-between gap-2">
      <label className="text-xs font-medium text-foreground">{label}</label>
      {hint && <span className="text-[11px] text-muted-foreground">{hint}</span>}
    </div>
    {children}
  </div>
);

export const ListEditor = ({ value, onChange, placeholder, testId, rows = 3 }) => (
  <AutoTextarea
    value={(value || []).join("\n")}
    onChange={(v) => onChange(v.split("\n").map((s) => s.replace(/^\s*[-•]\s*/, "")).filter((s, i, arr) => s.trim() || i === arr.length - 1))}
    placeholder={placeholder || "Un élément par ligne"}
    rows={rows}
    testId={testId}
  />
);

export const NumberInput = ({ value, onChange, min = 0, max = 100, testId }) => (
  <input
    type="number" min={min} max={max}
    value={value ?? ""}
    onChange={(e) => onChange(e.target.value === "" ? null : Math.max(min, Math.min(max, Number(e.target.value))))}
    data-testid={testId}
    className="w-16 text-sm rounded-lg border border-border bg-background px-2 py-1 text-center"
  />
);
